import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f225386a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f225386a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f225386a')) {
      api.createRecord('f225386a', component.options)
    } else {
      api.reload('f225386a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f225386a&scoped=true&", function () {
      api.rerender('f225386a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KuTqSRNjfXCQ/JS/comp/SearchFilterTokens.vue"
export default component.exports